import { useCallback, useSyncExternalStore, type ReactElement } from "react";
import { Toast } from "@primitives/index";
import { serviceWorkerUpdates } from "./serviceWorkerUpdates";

/**
 * "Einstein was updated — Reload." A non-blocking toast that stays until
 * the user reloads or dismisses it. Reload is the only path that lets the
 * waiting worker take over; dismissing leaves the current version running
 * until the next full load.
 */
export function ServiceWorkerUpdateToast(): ReactElement {
    const { updateReady } = useSyncExternalStore(
        serviceWorkerUpdates.subscribe,
        serviceWorkerUpdates.getSnapshot,
        serviceWorkerUpdates.getSnapshot,
    );

    const handleReload = useCallback(() => {
        serviceWorkerUpdates.applyUpdate();
    }, []);

    const handleDismiss = useCallback(() => {
        serviceWorkerUpdates.dismiss();
    }, []);

    return (
        <Toast
            open={updateReady}
            message="Einstein was updated."
            tone="info"
            action={{ label: "Reload", onClick: handleReload }}
            onDismiss={handleDismiss}
            autoHideMs={0}
            testId="sw-update-toast"
        />
    );
}
